module.exports = __webpack_public_path__ + "static/media/construction.39d8d45b.jpg";